module.exports = __webpack_public_path__ + "static/media/GameShowWin.00d351c0.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/GameShowWin.wav
// module id = 727
// module chunks = 0